// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__-c5ZC","choiceBoxes":"toolbarselects_choiceBoxes__3b3Eq","simpleField":"toolbarselects_simpleField__3NLVl"};